import { render, staticRenderFns } from "./LuogoEditModal.vue?vue&type=template&id=9a50e968&"
import script from "./LuogoEditModal.vue?vue&type=script&lang=ts&"
export * from "./LuogoEditModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports